var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('app-game-card',{attrs:{"game":_vm.game}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }